module.exports = __webpack_public_path__ + "img/Waves.1e42f282.svg";